// import axios from 'axios';
import api from './api';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api/v1';

// Create axios instance with auth token
const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const approvalService = {
  // Get all approvals with filters
  getAllApprovals: async (params = {}) => {
    const response = await api.get(`/approvals`, {
      headers: getAuthHeader(),
      params
    });
    return response.data.data;
  },

  // Get approval by ID
  getApprovalById: async (id) => {
    const response = await api.get(`/approvals/${id}`, {
      headers: getAuthHeader()
    });
    return response.data.data;
  },

  // Create new approval
  createApproval: async (approvalData) => {
    const response = await api.post(`/approvals`, approvalData, {
      headers: getAuthHeader()
    });
    return response.data.data;
  },

  // Update approval
  updateApproval: async (id, approvalData) => {
    const response = await api.put(`/approvals/${id}`, approvalData, {
      headers: getAuthHeader()
    });
    return response.data.data;
  },

  // Approve approval
  approveApproval: async (id, data) => {
    const response = await api.post(`/approvals/${id}/approve`, data, {
      headers: getAuthHeader()
    });
    return response.data.data;
  },

  // Reject approval
  rejectApproval: async (id, data) => {
    const response = await api.post(`/approvals/${id}/reject`, data, {
      headers: getAuthHeader()
    });
    return response.data.data;
  },

  // Escalate approval
  escalateApproval: async (id, data) => {
    const response = await api.post(`/approvals/${id}/escalate`, data, {
      headers: getAuthHeader()
    });
    return response.data.data;
  },

  // Cancel approval
  cancelApproval: async (id) => {
    const response = await api.post(`/approvals/${id}/cancel`, {}, {
      headers: getAuthHeader()
    });
    return response.data.data;
  },

  // Delete approval
  deleteApproval: async (id) => {
    const response = await api.delete(`/approvals/${id}`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Get my pending approvals (as approver)
  getMyPendingApprovals: async () => {
    const response = await api.get(`/approvals/my-pending`, {
      headers: getAuthHeader()
    });
    return response.data.data;
  },

  getApprovarsData: async (id,category) => {
    const response = await api.get(`/projects/${id}/approvers?category=${category}`);
    return response.data;
  },

  // Get my approval requests (as requester)
  getMyApprovalRequests: async (params = {}) => {
    const response = await api.get(`/approvals/my-requests`, {
      headers: getAuthHeader(),
      params
    });
    return response.data.data;
  }
};

export default approvalService;


